import React, { useState, useEffect } from 'react';
import {
    ArrowIcon,
    ImgContainer,
    LinkWrapper,
    PageName,
    PageNameContainer,
    PageSubText,
} from '../../styles/dropdown.style';
import PropTypes from 'prop-types';
import { useMediaQuery } from '@mui/material';
import Icon_right from '../../../../images/Icons/at_chevron-right.svg';

const PageLink = ({ item }) => {
    const currentPath = window.location.pathname;
    const isSmallScreen = useMediaQuery('(max-width: 760px)');
    const [imageLoaded, setImageLoaded] = useState(false);

    // Preload image when component mounts
    useEffect(() => {
        if (item.img && !isSmallScreen) {
            const img = new Image();
            img.onload = () => setImageLoaded(true);
            img.src = item.img;
        }
    }, [item.img, isSmallScreen]);

    return (
        <LinkWrapper>
            <PageNameContainer>
                <PageName active={currentPath === item.link}>{item.label}</PageName>
                <ArrowIcon src={Icon_right} alt="icon-right" active={currentPath === item.link} />
            </PageNameContainer>
            <PageSubText>{item.subText}</PageSubText>
            {!isSmallScreen && item.img && (
                <ImgContainer>
                    <img
                        src={item.img}
                        alt={`${item.label}-img`}
                        style={{
                            opacity: imageLoaded ? 1 : 0.3,
                            transition: 'opacity 0.3s ease',
                        }}
                    />
                </ImgContainer>
            )}
        </LinkWrapper>
    );
};

PageLink.propTypes = {
    item: PropTypes.object,
};

export default PageLink;
